import { SxProps, Theme } from '@mui/material';
import { TEXT_DARK, TEXT_LIGHT_GRAY } from '../../../styles/GlobalStyles';

export type BadgeVariant = 'primary' | 'success' | 'neutral';
export type BadgeSize = 'regular' | 'compact';

interface BadgeStyleOptions {
  variant: BadgeVariant;
  size: BadgeSize;
  bordered: boolean;
}

const BADGE_VARIANT_STYLES: Record<BadgeVariant, { backgroundColor: string; color: string }> = {
  primary: {
    backgroundColor: 'primary.main',
    color: 'primary.contrastText',
  },
  success: {
    backgroundColor: '#8DC153',
    color: '#FFFFFF',
  },
  neutral: {
    backgroundColor: '#F7F7F7',
    color: TEXT_DARK,
  },
};

export const badgeTooltipSlotProps = {
  tooltip: {
    sx: {
      fontSize: '16px',
      lineHeight: 1.4,
      maxWidth: '360px',
      whiteSpace: 'normal',
    },
  },
};

export const badgeStyles = {
  container: () =>
    ({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1px',
    }) as SxProps<Theme>,

  label: (theme: Theme) =>
    ({
      fontSize: '10px',
      color: TEXT_LIGHT_GRAY,
      fontWeight: 400,
      whiteSpace: 'nowrap',
      lineHeight: 1.2,
    }) as SxProps<Theme>,

  badge: (theme: Theme, options: BadgeStyleOptions) => {
    const { variant, size, bordered } = options;
    const variantStyle = BADGE_VARIANT_STYLES[variant];

    return ({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      boxSizing: 'border-box',
      backgroundColor: variantStyle.backgroundColor,
      color: variantStyle.color,
      fontSize: theme.typography.caption.fontSize,
      fontWeight: 400,
      borderRadius: '3px',
      whiteSpace: 'nowrap',
      border: bordered ? '2px solid #929292' : 'none',
      height: size === 'regular' ? '28px' : 'auto',
      minHeight: size === 'compact' ? '18px' : undefined,
      minWidth: size === 'compact' ? '45px' : undefined,
      padding: size === 'regular' ? theme.spacing(0, 1.5) : theme.spacing(0.25, 0.75),
    }) as SxProps<Theme>;
  },
};

export default badgeStyles;
